<template>
  <div class="bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen transition-colors duration-300">
    <Navbar />
    <main class="max-w-4xl mx-auto px-4 py-24">
      <header class="mb-12">
        <h1 class="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">{{ t('articles') }}</h1>
        <!-- <p class="text-lg text-gray-600 dark:text-gray-400">{{ t('articlesDescription') }}</p> -->
      </header>

      <div v-if="Object.keys(posts_grouped).length === 0" class="text-center py-12">
        <p class="text-gray-500 dark:text-gray-400">{{ t('noArticlesYet') }}</p>
      </div>

      <div v-else class="space-y-12">
        <section v-for="(posts, monthYear) in posts_grouped" :key="monthYear">
          <!-- Month header -->
          <h2 class="text-sm font-bold uppercase tracking-wider text-amber-600 dark:text-amber-400 mb-4 pb-2 border-b border-gray-200 dark:border-gray-700">
            {{ formatMonth(monthYear) }}
          </h2>

          <!-- Posts list -->
          <div class="space-y-1">
            <article
              v-for="post in posts"
              :key="post.slug"
              class="group"
            >
              <Link :href="`/articles/${post.slug}`" class="flex items-start gap-4 py-3 px-2 -mx-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                <!-- Day number -->
                <span class="text-2xl font-light text-gray-300 dark:text-gray-600 w-10 text-right flex-shrink-0">
                  {{ post.day }}
                </span>

                <!-- Post content -->
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2">
                    <h3 class="text-lg font-medium text-gray-900 dark:text-white group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors">
                      {{ post.title }}
                    </h3>
                    <span
                      v-if="post.lang"
                      class="px-1.5 py-0.5 rounded text-[10px] font-bold uppercase"
                      :class="post.lang === 'pt-BR' ? 'bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-400' : 'bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-400'"
                    >
                      {{ post.lang === 'pt-BR' ? 'PT' : 'EN' }}
                    </span>
                  </div>
                  <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5 line-clamp-2">{{ post.excerpt }}</p>
                  <div v-if="post.tags.length" class="flex gap-2 mt-2">
                    <span
                      v-for="tag in post.tags"
                      :key="tag"
                      class="px-2 py-0.5 bg-gray-100 dark:bg-gray-800 rounded-full text-xs text-gray-600 dark:text-gray-400"
                    >
                      {{ tag }}
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import { useI18n } from '@/i18n'

const { t, formatMonth } = useI18n()

defineProps({
  posts_grouped: {
    type: Object,
    default: () => ({})
  },
  years: {
    type: Array,
    default: () => []
  }
})
</script>
